import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';
import { useCurrentOrganization } from 'hooks/api/useCurrentOrganization';

export function useSetupPayment(options?: UseQueryOptions<string, APIError>) {
  const { client } = useAPI();
  const { data: organization } = useCurrentOrganization();

  return useAuthenticatedQuery(
    ['client_key'],
    async () => {
      if (!organization) {
        return Promise.reject(new Error('No organization.'));
      }

      const { data } = await client.post<string>(
        `/internal/orgs/${organization.id}/payment_setup`
      );
      return data;
    },
    { ...options, cacheTime: 0 }
  );
}
